import { Box, Typography, useTheme } from "@mui/material";
import { tokens, useHideMode } from "../theme";
import ProgressCircle from "./ProgressCircle";

const BigBucketBox = ({ amount, cap, title, icon, progress }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const hideTheme = useHideMode();

    return (
        <Box width="100%" m="0 30px" >
            <Box display="flex" justifyContent="space-between">
                <Box>
                    {icon}
                    <Typography
                        variant="h2"
                        fontWeight="bold"
                        sx={{ color: colors.grey[100] }}
                    >
                        {hideTheme.mode === "show" ? amount : '*'.repeat(9)}
                    </Typography>
                    <Typography
                        variant="h4"
                        fontWeight="bold"
                        sx={{ color: colors.grey[100] }}
                    >
                        -------------------------
                    </Typography>
                    <Typography
                        variant="h2"
                        fontWeight="bold"
                        sx={{ color: colors.grey[100] }}
                    >
                        {hideTheme.mode === "show" ? cap : '*'.repeat(9)}
                    </Typography>
                </Box>
                <Box marginTop="2%">
                    <ProgressCircle progress={progress} size={250} />
                </Box>
            </Box>
            <Box display="flex" justifyContent="space-between" mt="2px" mr="11%">
                <Typography variant="h3" sx={{ color: colors.blueAccent[500] }}>
                    {title}
                </Typography>

            </Box>
        </Box >
    );
};

export default BigBucketBox;

